import { Injectable, inject } from '@angular/core';

import { of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { AdministratorCRUDService } from '@digitalforest/ngx-oak-api';

import { AdministratorActions } from './administrator.actions';
import { ApiKeyInfoActions } from './api-key-info.actions';

@Injectable()
export class AdministratorEffects {
  private actions$: Actions = inject(Actions);
  private administratorCRUDService: AdministratorCRUDService = inject(AdministratorCRUDService);

  loadAdministrator$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdministratorActions.load),
      tap(() => console.debug('[AdministratorEffects] loadAdministrator')),
      switchMap(({ administratorId }) =>
        this.administratorCRUDService.manageGetAdministrator(administratorId).pipe(
          tap((administrator) =>
            console.debug(`[AdministratorEffects] loadAdministrator: administrator = ${JSON.stringify(administrator)}`),
          ),
          switchMap((administratorReadOnlySchema) =>
            of(AdministratorActions.loadSuccess({ administrator: administratorReadOnlySchema }), ApiKeyInfoActions.load()),
          ),
          catchError((error) => {
            console.debug(`[AdministratorEffects] loadAdministrator: error = ${JSON.stringify(error)}`);
            return of(AdministratorActions.loadFailure({ error }));
          }),
        ),
      ),
    ),
  );
}
